(function () {
  document.querySelectorAll(".hrc-hero-slider").forEach(function (slider) {
    var slides = slider.querySelectorAll(".hrc-hero-slide");
    var n = slides.length;
    if (n < 1) return;

    if (slider.getAttribute("data-hrc-ready") === "1") return;
    slider.setAttribute("data-hrc-ready", "1");

    var i = 0;
    var autoplay = slider.getAttribute("data-autoplay") === "true";
    var speed =
      parseInt(slider.getAttribute("data-autoplay-speed"), 10) || 6000;
    speed = speed > 0 ? speed : 6000;
    var timer = null;

    function isShown(el) {
      if (!el) return false;
      return window.getComputedStyle(el).display !== "none";
    }

    function visibleVideos(slide) {
      var videos = slide.querySelectorAll("video.hrc-hs-visual-video");
      var out = [];
      videos.forEach(function (v) {
        if (!isShown(v)) return;
        var slot = v.closest(".hrc-hs-video-slot");
        if (slot && !isShown(slot)) return;
        out.push(v);
      });
      return out;
    }

    function pauseSlide(slide) {
      slide.querySelectorAll("video.hrc-hs-visual-video").forEach(function (v) {
        v.pause();
        try {
          v.currentTime = 0;
        } catch (err) {}
      });
    }

    function playSlide(slide) {
      visibleVideos(slide).forEach(function (v) {
        v.playsInline = true;
        if (v.hasAttribute("muted")) v.muted = true;
        var playPromise = v.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      });
    }

    function scheduleNext() {
      if (!autoplay || n < 2) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        goTo(i + 1);
      }, speed);
    }

    function goTo(idx) {
      i = ((idx % n) + n) % n;
      slides.forEach(function (el, j) {
        var active = j === i;
        el.classList.toggle("hrc-active", active);
        if (active) playSlide(el);
        else pauseSlide(el);
      });
      scheduleNext();
    }

    slider.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") goTo(i - 1);
      if (e.key === "ArrowRight") goTo(i + 1);
    });

    slides.forEach(function (el, j) {
      if (j === 0) playSlide(el);
      else pauseSlide(el);
    });
    if (autoplay && n > 1) scheduleNext();

    var breakpointMq = window.matchMedia("(max-width: 768px)");
    function onBreakpointChange() {
      slides.forEach(function (el, j) {
        el.querySelectorAll("video.hrc-hs-visual-video").forEach(function (v) {
          v.pause();
        });
        if (j === i) playSlide(el);
      });
    }
    if (breakpointMq.addEventListener) {
      breakpointMq.addEventListener("change", onBreakpointChange);
    } else if (breakpointMq.addListener) {
      breakpointMq.addListener(onBreakpointChange);
    }
  });
})();
